import {
  FETCH_PATIENTS,
  FETCH_PATIENTS_SUCCESS,
  FETCH_MORE_PATIENTS,
  FETCH_MORE_PATIENTS_SUCCESS,
  FILTER_PATIENTS,
  GET_PATIENTS,
  HANDLE_REQUEST_CLOSE,
  HIDE_PATIENTS_LOADER,
  SHOW_PATIENTS_LOADER,
  ON_ADD_PATIENT,
  ON_PATIENT_CLOSE,
  ON_DELETE_PATIENT,
  DELETE_PATIENT_SUCCESS,
  FETCH_STARTED_PATIENTS,
  FETCH_STARTED_PATIENTS_SUCCESS,
  ON_SAVE_PATIENT,
  ON_TOGGLE_DRAWER,
  SHOW_PATIENT_MESSAGE,
  SAVE_PATIENT_SUCCESS,
  SHOW_MORE_PATIENTS_LOADER
} from 'constants/ActionTypes';


export const fetchPatients = () => {
  return {
    type: FETCH_PATIENTS
  };
};
export const fetchMorePatients = (lastEvaluatedKey, pageSectionId) => {
  return {
    type: FETCH_MORE_PATIENTS,
    payload: { lastEvaluatedKey, pageSectionId }
  };
};
export const fetchPatientsSuccess = (patients) => {
  return {
    type: FETCH_PATIENTS_SUCCESS,
    payload: patients
  }
};
export const fetchMorePatientsSuccess = (patients) => {
  return {
    type: FETCH_MORE_PATIENTS_SUCCESS,
    payload: patients
  }
};
export const showPatientsMessage = (message, messageStatus = false) => {
  return {
    type: SHOW_PATIENT_MESSAGE,
    payload: {message, messageStatus}
  };
};
export const onAddPatient = () => {
  return {
    type: ON_ADD_PATIENT
  };
};
export const onPatientClose = () => {
  return {
    type: ON_PATIENT_CLOSE
  };
};
export const onDeletePatientClose = () => {
  return {
    type: ON_DELETE_PATIENT_CLOSE
  };
};
export const fetchStartedPatients = () => {
  return {
    type: FETCH_STARTED_PATIENTS
  };
};
export const fetchStartedPatientsSuccess = (patients) => {
  return {
    type: FETCH_STARTED_PATIENTS_SUCCESS,
    payload: patients
  };
};
export const onSavePatient = (data, isFavoriteRemoved) => {
  return {
    type: ON_SAVE_PATIENT,
    payload: data,
    isFavoriteRemoved: isFavoriteRemoved
  };
};
export const savePacientSuccess = (data) => {
  return {
    type: SAVE_PATIENT_SUCCESS,
    payload: data
  };
};
export const onDeletePatient = (data) => {
  return {
    type: ON_DELETE_PATIENT,
    payload: data
  };
};
export const deletePacientSuccess = (data) => {
  return {
    type: DELETE_PATIENT_SUCCESS,
    payload: data
  };
};
export const filterPatients = (data) => {
  return {
    type: FILTER_PATIENTS,
    payload: data
  };
};
export const getAllPatients = () => {
  return {
    type: GET_PATIENTS,
    payload: ''
  };
};
export const onToggleDrawer = () => {
  return {
    type: ON_TOGGLE_DRAWER
  };
};
export const handleRequestClose = () => {
  return {
    type: HANDLE_REQUEST_CLOSE
  };
};
export const hidePatientsLoader = () => {
  return {
    type: HIDE_PATIENTS_LOADER
  };
};
export const showPatientsLoader = () => {
  return {
    type: SHOW_PATIENTS_LOADER
  };
};
export const showMorePatientsLoader = () => {
  return {
    type: SHOW_MORE_PATIENTS_LOADER
  };
};




// WEBPACK FOOTER //
// ./actions/Patients.js